(() => {
  'use strict';

  const MAIN_TEXT = 'button[data-add-to-cart]:not([data-add-to-cart-bar]) [data-add-to-cart-text]';
  const STICKY_TEXT = '[data-add-to-cart-bar] [data-add-to-cart-text]';

  function syncCartBarCopy() {
    const main = document.querySelector(MAIN_TEXT);
    const sticky = document.querySelector(STICKY_TEXT);

    if (!main || !sticky || main === sticky) return;
    if (sticky.innerHTML === main.innerHTML) return;

    sticky.innerHTML = main.innerHTML;
  }

  function init() {
    const main = document.querySelector(MAIN_TEXT);
    if (!main) return;

    syncCartBarCopy();

    const observer = new MutationObserver(syncCartBarCopy);
    const observeTarget = main.closest('[data-add-to-cart]') || main;

    observer.observe(observeTarget, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!target?.matches?.('[name="selling_plan"], [name="selling-plan-group"], [data-toggles-group]')) return;

      requestAnimationFrame(syncCartBarCopy);
      setTimeout(syncCartBarCopy, 50);
      setTimeout(syncCartBarCopy, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
